var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert-feedback",attrs:{"color":_vm.feedback.color,"transition":"scale-transition","dark":"","dismissible":"","border":"left","value":_vm.feedback.feedback}},[_vm._v(_vm._s(_vm.feedback.text))])}
var staticRenderFns = []

export { render, staticRenderFns }